module.exports = __webpack_public_path__ + "img/icon-search.d4dcb162.svg";